'use strict';
angular.module('meanApp')
  .config(function ($stateProvider) {
    $stateProvider
      .state('step3', {
        url: '/step3/:clientId',
        params: {},
        templateUrl: 'app/tpcPortal/step3/step3.html',
        controller: 'step3-controller',
        authenticate: ['user', 'admin']
      });
  });
